export const PRESET_SIZES = {
	default: { w: 200, h: 259 },
} as const;

export const EXTENSION = 'png';

export const CONTENTS = ['image_1', 'image_2', 'image_3'] as const;
